import { render, staticRenderFns } from "./LayoutDemo.vue?vue&type=template&id=2cdb7cab&"
import script from "./layoutDemo.js?vue&type=script&lang=js&"
export * from "./layoutDemo.js?vue&type=script&lang=js&"
import style0 from "./LayoutDemo.vue?vue&type=style&index=0&id=2cdb7cab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports